import React from "react";
import Icon from "../../../components/Icon";
import ImageDropField from "./ImageDropField";
import { LANGS } from "../shared";
import styles from "./SectionsEditor.module.sass";

const emptySection = () => ({
  title: LANGS.reduce((acc, l) => ({ ...acc, [l]: "" }), {}),
  body: LANGS.reduce((acc, l) => ({ ...acc, [l]: "" }), {}),
  imageUrl: "",
  imageByLang: LANGS.reduce((acc, l) => ({ ...acc, [l]: "" }), {}),
});

/** Captura efectiva de la sección en un idioma: la suya o, si falta, la de ES / por defecto. */
const imageFor = (section, lang) =>
  section.imageByLang?.[lang] || section.imageByLang?.es || section.imageUrl || "";

/**
 * SECCIONES del correo de Bāo (template="bao"): bloques numerados con titular,
 * párrafo y captura. Estructura compartida entre idiomas, texto por idioma —
 * igual que el editor de bloques.
 */
const SectionsEditor = ({ sections, onChange, lang, disabled, onNotify }) => {
  const update = (index, patch) =>
    onChange(sections.map((s, i) => (i === index ? { ...s, ...patch } : s)));

  const move = (index, delta) => {
    const next = [...sections];
    const target = index + delta;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <div className={styles.title}>Secciones del correo</div>
        <div className={styles.hint}>Con captura van a la galería; sin captura, como bloque de texto. Las usan las plantillas Bāo y Paywall.</div>
      </div>

      {sections.map((section, index) => (
        <div className={styles.section} key={index}>
          <div className={styles.num}>{index + 1}</div>
          <div className={styles.fields}>
            <input
              className={styles.input}
              placeholder={`Titular (${lang.toUpperCase()})`}
              value={section.title?.[lang] || ""}
              disabled={disabled}
              onChange={(e) =>
                update(index, { title: { ...section.title, [lang]: e.target.value } })
              }
            />
            <textarea
              className={styles.textarea}
              rows={3}
              placeholder={`Texto (${lang.toUpperCase()})`}
              value={section.body?.[lang] || ""}
              disabled={disabled}
              onChange={(e) =>
                update(index, { body: { ...section.body, [lang]: e.target.value } })
              }
            />
            <ImageDropField
              value={section.imageByLang?.[lang] || ""}
              onChange={(url) =>
                update(index, { imageByLang: { ...(section.imageByLang || {}), [lang]: url } })
              }
              disabled={disabled}
              onNotify={onNotify}
            />
            <div className={styles.imageLangs}>
              <span>Captura en {lang.toUpperCase()}</span>
              {LANGS.map((l) => (
                <span
                  key={l}
                  className={section.imageByLang?.[l] ? styles.langOn : styles.langOff}
                  title={section.imageByLang?.[l] ? "Tiene captura propia" : "Usa la captura por defecto"}
                >
                  {l.toUpperCase()}
                </span>
              ))}
              {!section.imageByLang?.[lang] && imageFor(section, lang) && (
                <span className={styles.fallback}>· sin captura propia, se usa la de ES</span>
              )}
            </div>
          </div>
          {imageFor(section, lang) && (
            <img className={styles.thumb} src={imageFor(section, lang)} alt="" />
          )}
          {!disabled && (
            <div className={styles.actions}>
              <button type="button" className={styles.action} onClick={() => move(index, -1)}>
                <Icon name="arrow-top" size="16" />
              </button>
              <button type="button" className={styles.action} onClick={() => move(index, 1)}>
                <Icon name="arrow-bottom" size="16" />
              </button>
              <button
                type="button"
                className={styles.action}
                onClick={() => onChange(sections.filter((_, i) => i !== index))}
              >
                <Icon name="trash" size="16" />
              </button>
            </div>
          )}
        </div>
      ))}

      {!disabled && (
        <button
          type="button"
          className={styles.add}
          onClick={() => onChange([...sections, emptySection()])}
        >
          + Añadir sección
        </button>
      )}
    </div>
  );
};

export default SectionsEditor;
